import React from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

export default function FinalCTA() {
  return (
    <section id="cta" data-testid="final-cta-section" className="relative py-20 sm:py-32 lg:py-44 overflow-hidden border-t border-[#0E1A1A]">
      <div className="absolute inset-0 grid-bg opacity-50" aria-hidden />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[1000px] h-[600px] glow-vermilion opacity-40" aria-hidden />

      <div className="max-w-[1200px] mx-auto px-6 lg:px-12 relative text-center">
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          data-testid="final-cta-headline"
          className="font-display text-balance text-4xl sm:text-5xl lg:text-7xl tracking-[-0.04em] leading-[1.02] font-medium max-w-4xl mx-auto"
        >
          Contractor operations without the <span className="italic font-normal text-[#9BB8B8]">operational</span> burden.
        </motion.h2>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.2 }}
          className="mt-8 sm:mt-10 flex flex-col sm:flex-row gap-3 justify-center items-stretch sm:items-center"
        >
          <a
            href="https://nexus-vs.vawick.com/signin"
            data-testid="final-cta-primary"
            className="group inline-flex items-center justify-center gap-2 bg-white text-black px-6 py-3.5 rounded-full font-medium text-sm hover:bg-[#FF4F00] hover:text-white transition-all duration-300"
          >
            Request Demo
            <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
          </a>
          <a
            href="mailto:support@vawick.de"
            data-testid="final-cta-secondary"
            className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-full font-medium text-sm border border-[#152222] hover:border-[#1F3535] hover:bg-[#0D1A1A] transition"
          >
            Talk to us
          </a>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.35 }}
          className="mt-8 text-xs text-[#7A9B9B] font-mono flex flex-wrap items-center justify-center gap-x-3 gap-y-1"
        >
          <span>Custom onboarding</span>
          <span className="text-[#1F3535]">·</span>
          <span>Dedicated setup</span>
          <span className="text-[#1F3535]">·</span>
          <motion.span
            animate={{
              textShadow: [
                "0 0 0px rgba(74,222,128,0)",
                "0 0 12px rgba(74,222,128,0.9)",
                "0 0 0px rgba(74,222,128,0)",
              ],
              color: ["#4A6E6E", "#4ADE80", "#4A6E6E"],
            }}
            transition={{ duration: 2.4, repeat: Infinity, ease: "easeInOut" }}
          >
            SOC-2 in progress
          </motion.span>
        </motion.div>
      </div>
    </section>
  );
}
